import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerRequestApproval from "./BannerRequestApproval"
import CTASignUpLong from "@components/CTASignUpLong"
import TopTitle from "@components/TopTitle"
import Footer from "@components/Footer"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"
import styles from "./request-approvals.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"
import ApprovalImg from "./approve.png"

const Home = props => {
  return (
    <div>
      <EngineIDNavBar />
      <BannerRequestApproval />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <section className="container-fluid bg-xl-light-gray">
              <div className="row ml-0 mr-0">
                  <Wrapper className={"w-100 text-left"} gap="outer">
                      <WrapperInner className="row bg-white p-6">
                          <div className={styles.padContent}>
                            <div className={props.className + " col-12"}>
                                <div className="text-center">
                                    <h3>
                                        <div className="proxima-nova--extra-bold text-secondary fs-30pt fs-lg-40pt fs-xl-42pt">
                                          REQUESTS AND APPROVALS
                                        </div>
                                        <TopTitle content="STREAMLINE YOUR ACCESS MANAGEMENT IN YOUR BUSINESS" />
                                    </h3>
                                </div>
                            </div>
                            <div className="row bg-white p-6">
                                <p className="left-paragraph">
                                  It’s hard to know exactly what applications and systems staff  need to do their jobs. People change job 
                                  roles, they join new teams, start new projects and cover for colleagues when they go on leave. The 
                                  access someone gets when they join your organization is bound to change over time.
                                </p>
                                
                                <p className="left-paragraph float-left">
                                
                                  Adapting to these constant changes takes a lot of effort and time out of your day. Trying to remember who 
                                  was granted access to an application and for what reason becomes a never-ending struggle that will end up 
                                  with security holes and impossible administrative overheads.
                                </p>

                                <p className="left-paragraph">
                                <img src={ApprovalImg} class="float-left pull-left mr-2" />
                                  That’s why 'request and approvals' has been built directly into EngineID, a cloud software platform that solves 
                                  user management challenges in your organization. Users can request the access to applications and systems they need with 
                                  written justifications. The decision to approve or deny the request is stored for posterity so you can take 
                                  all the guess work out of why a staff member has the access they’ve been given.
                                </p>
                                <p className="left-paragraph">
                                  Using the request and approvals functionality in EngineID gives your organization the following benefits:
                                </p>


                                <div className={
                                  styles.list + " " +
                                  styles.bulletDescription + " col-12 pl-5"}>
                                    <span>Let your users request the access they need for their job</span><br />
                                    <span>Set up approval workflows to make sure the right people approve or deny requests</span><br />
                                    <span>Reduce cost and overhead on your helpdesk by introducing self-service capability</span><br />
                                    <span>Automatic assignment of access upon approval</span><br />
                                    <span>Improve auditability by using the request history search</span><br />
                                    <span>Real-time notifications when approvals are pending and when approval decisions are made</span><br />
                                </div>
                            </div>
                            <div className={props.className + " col-12"}>
                                <div className="text-center">
                                      <TopTitle content="HOW EASY IT IS TO USE?" />
                                </div>
                            </div>
                            <div className="row bg-white p-6">
                                <p className="left-paragraph">
                                  EngineID has been designed from the ground-up to be simple and easy for any sized organization and our request and approval 
                                  functionality is no exception. You decide what access you would like staff to be able to request, you decide how simple or 
                                  complex an approval process is (you can have multiple levels of approval if you like!) and then you are ready to go.
                                </p>
                                <p className="left-paragraph">
                                  Staff members simply log in to EngineID, search for the access they need, provide a reason for their request and submit, that’s it!
                                </p>
                                <p className="left-paragraph">
                                  Whoever is the approver for that specific access will be notified in real time via email (or Slack!) asking for their approval or deny 
                                  response. When the approval process completes successfully, EngineID will automatically assign the access to the staff member. It’s 
                                  all done for you behind the scenes.
                                </p>
                            </div>
                            <div className={props.className + " col-12"}>
                                <div className="text-center">
                                    <TopTitle content="DOES IT COST EXTRA?" />
                                </div>
                            </div>
                            <div className="row bg-white p-6">
                                <p className="left-paragraph">
                                  No, this is included with all EngineID organizations (even the free tier). Sign up on our <OutboundLink target="_blank" href="https://app.engineid.com/register">free tier</OutboundLink> today 
                                  and try it out for yourself, or <OutboundLink target="_blank" href="/contact-us">contact us</OutboundLink> and we will be happy to give you a demo.
                                </p>
                            </div>
                            <div className={props.className + " col-12"}>
                                <div className="text-center">
                                    <TopTitle content="STAFF SATISFACTION" />
                                </div>
                            </div>
                            <div className="row bg-white p-6">
                                <p className="left-paragraph">
                                  Empowering your employees to set themselves up goes a long way to improving satisfaction across your organization. If staff feel like they 
                                  are being held back through bottlenecks, red tape and slow manual process, frustration grows which inevitably leads to resentment.
                                </p>
                                <p className="left-paragraph">
                                  Building a fast, accountable and organized business improves the state of mind of your employees. Using a modern system 
                                  like EngineID as the cornerstone to streamlining and automating cumbersome manual processes will give you the confidence 
                                  to focus on what is most important, your business.
                                </p>
                            </div>
                            <div className={props.className + " col-12"}>
                                <div className="text-center">
                                    <TopTitle content="WHAT ARE YOU WAITING FOR?" />
                                </div>
                            </div>
                            <div className="row bg-white p-6">
                                <p className="left-paragraph">
                                  If you want more information about the most comprehensive cloud-based Identity and Access Governance solution
                                  in the market today, you can contact us through this site: <OutboundLink target="_blank" href="/contact-us">contact us</OutboundLink> and we will be happy to answer any questions you might have.
                                </p>
                            </div>
                          </div>
                      </WrapperInner>
                  </Wrapper>
              </div>
          </section>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Home
